import layout from './SettingsView.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import View from '@/Views/View';

export default class SettingsView extends View {

    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: any, private element?: JQuery) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null)
            return this.view;

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('SettingsView', SettingsView, 'RADPresentation.HTMLClient.DefaultViewExtensions');